<div class="alert alert-dismissible" [ngClass]="cssClass()" *ngIf="visible">
  <button type="button" class="close" [attr.aria-label]="'COMPONENTS.Close' | translate" (click)="hide()"><span aria-hidden="true">&times;</span></button>
  {{ message }}&nbsp;
</div>
